<template>
  <div class="cw-page">
    <WhatsappEditar :exame="formData" :showForm="showFormEdit" :parent="this" />
    <WhatsappTeste :exame="formData" :showForm="showFormTeste" :parent="this" />
    <WhatsappTemplates :showForm.sync="showFormTemplates" :parent="this" />

    <!-- CABEÇALHO -->
    <div class="cw-toolbar">
      <button class="cw-btn cw-btn-primary" @click="onRegister">
        <i class="fa fa-plus"></i> Nova Conta
      </button>

      <div class="cw-search">
        <i class="fa fa-search cw-search-icon"></i>
        <input
          type="text"
          v-model="search"
          placeholder="Buscar por nome ou phone number ID..."
          @keyup.enter="handleSearch"
        />
        <button v-if="search" class="cw-search-clear" title="Limpar busca" @click="handleClearSearch">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <!-- LOADING -->
    <div v-if="loadingTable" class="cw-loading">
      <i class="fa fa-spinner fa-spin"></i> Carregando contas...
    </div>

    <!-- ESTADO VAZIO -->
    <div v-else-if="tableData.length === 0" class="cw-empty">
      <div class="cw-empty-icon"><i class="fa fa-whatsapp"></i></div>
      <p class="cw-empty-title">{{ search ? 'Nenhuma conta encontrada' : 'Nenhuma conta WhatsApp cadastrada' }}</p>
      <p class="cw-empty-subtitle" v-if="!search">Cadastre uma conta para começar a enviar mensagens via WhatsApp Business</p>
      <button class="cw-btn cw-btn-primary" v-if="!search" @click="onRegister">
        <i class="fa fa-plus"></i> Nova Conta
      </button>
    </div>

    <!-- LISTA DE CONTAS -->
    <div v-else class="cw-list">
      <div v-for="item in tableData" :key="item.id" class="cw-card">
        <div class="cw-card-icon"><i class="fa fa-whatsapp"></i></div>

        <div class="cw-card-main">
          <div class="cw-card-name">{{ item.nome }}</div>
          <div class="cw-card-ids">
            <span class="cw-card-id">
              <i class="fa fa-phone"></i> {{ item.phone_number_id }}
            </span>
            <span class="cw-card-id">
              <i class="fa fa-building"></i> {{ item.business_account_id }}
            </span>
          </div>
        </div>

        <div class="cw-card-actions">
          <button class="cw-icon-btn" title="Templates de Mensagem" @click="onTemplates(item)">
            <i class="fa fa-comments"></i>
          </button>
          <button class="cw-icon-btn" title="Enviar WhatsApp Teste" @click="onTest(item)">
            <i class="fa fa-paper-plane"></i>
          </button>
          <button
            class="cw-icon-btn"
            title="Editar Conta"
            :disabled="!validarPermissao(592)"
            @click="onEdit(item)"
          >
            <i class="fa fa-pencil"></i>
          </button>
          <button
            class="cw-icon-btn cw-icon-btn-danger"
            title="Excluir Conta"
            :disabled="!validarPermissao(592)"
            @click="onDelete([item.id])"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <div v-if="pagination && pagination.last_page && pagination.last_page > 1" class="cw-pagination">
      <ed-paginate :pagination="pagination" :navigation="handleNavigate" />
    </div>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdPaginate from "common/paginate";
import WhatsappEditar from "./editar";
import WhatsappTeste from "./teste";
import WhatsappTemplates from "./templates";

export default {
  name: "conta-whatsapp",
  components: { EdPaginate, WhatsappEditar, WhatsappTeste, WhatsappTemplates },
  mixins: [Rest],
  data() {
    return {
      formData: {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      },
      search: null,
      pagination: {},
      response: {},
      tableData: [],
      loadingTable: false,
      showFormEdit: false,
      showFormTeste: false,
      showFormTemplates: false
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },

  created() {
    var clienteId = this.cliente && this.cliente.logged ? this.cliente.logged.id : null;
    if (clienteId !== 1 && clienteId !== 914) {
      this.$router.replace('/');
      return;
    }
  },

  mounted: function() {
    this.getContaWhatsapp();
  },

  methods: {
    onRegister: function() {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      };
    },

    onEdit: function(data) {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: data.id,
        nome: data.nome,
        phone_number_id: data.phone_number_id,
        business_account_id: data.business_account_id,
        access_token: null
      };
    },

    onDelete: function(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      ).then(() => {
        self.loadingTable = true;

        this.post("/conta-whatsapp/deletar", { ids: data }).then(result => {
          result = result[0];
          self.loadingTable = false;

          if (result.status == 200) {
            self.getContaWhatsapp();
            self.edMsg("Registro excluído com sucesso");
          }
        });
      });
    },

    onTest(data) {
      this.showFormTeste = !this.showFormTeste;
      this.formData = {
        id: data.id,
        nome: data.nome
      };
    },

    onTemplates(data) {
      this.formData = {
        id: data.id,
        nome: data.nome
      };
      this.showFormTemplates = true;
    },

    handleSearch() {
      this.getContaWhatsapp(this.search, 1, this.pagination.per_page);
    },

    handleClearSearch() {
      this.search = null;
      this.getContaWhatsapp();
    },

    handleNavigate(page) {
      this.getContaWhatsapp(this.search, page, this.pagination.per_page);
    },

    getContaWhatsapp: function(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.get("conta-whatsapp", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(result => {
        result = result[0];
        this.response = result;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            tableData.push({
              id: data[i].id,
              nome: data[i].nome,
              phone_number_id: data[i].phone_number_id,
              business_account_id: data[i].business_account_id
            });
          }

          this.pagination = pagination;
          this.tableData = tableData;
          this.loadingTable = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cw-page {
  padding-top: 4px;
}

// TOOLBAR
.cw-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 20px;
}

.cw-search {
  position: relative;
  width: 100%;
  max-width: 420px;
  display: flex;
  align-items: center;

  input {
    width: 100%;
    height: 40px;
    padding: 0 36px;
    border: 1px solid #dcdfe6;
    border-radius: 20px;
    font-size: 13px;
    color: #303133;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      outline: none;
      border-color: #409eff;
      box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }

    &::placeholder {
      color: #c0c4cc;
    }
  }
}

.cw-search-icon {
  position: absolute;
  left: 13px;
  color: #c0c4cc;
  font-size: 13px;
  pointer-events: none;
}

.cw-search-clear {
  position: absolute;
  right: 8px;
  border: none;
  background: none;
  color: #c0c4cc;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;

  &:hover {
    background: #f2f3f5;
    color: #909399;
  }
}

// BOTÕES
.cw-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 18px;
  border-radius: 20px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}

.cw-btn-primary {
  background: #25d366;
  color: #fff;

  &:hover {
    background: #20bd5a;
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.35);
  }
}

// LOADING
.cw-loading {
  text-align: center;
  padding: 60px 0;
  color: #909399;
  font-size: 14px;

  i {
    margin-right: 8px;
  }
}

// EMPTY STATE
.cw-empty {
  text-align: center;
  padding: 60px 20px;
  border: 1px dashed #dcdfe6;
  border-radius: 10px;
}

.cw-empty-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: #eefaf0;
  color: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
}

.cw-empty-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 4px;
}

.cw-empty-subtitle {
  font-size: 13px;
  color: #909399;
  margin: 0 0 20px;
}

// LISTA DE CARDS
.cw-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cw-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #d1e9ff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }
}

.cw-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #eefaf0;
  color: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.cw-card-main {
  flex: 1;
  min-width: 0;
}

.cw-card-name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cw-card-ids {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 4px;
}

.cw-card-id {
  font-size: 12px;
  color: #909399;

  i {
    margin-right: 5px;
    width: 12px;
  }
}

.cw-card-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.cw-icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  background: #fafafa;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    background: #ecf5ff;
    color: #409eff;
    border-color: #d1e9ff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &.cw-icon-btn-danger:hover:not(:disabled) {
    background: #fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }
}

// PAGINAÇÃO
.cw-pagination {
  text-align: center;
  margin-top: 20px;
}

@media only screen and (max-width: 700px) {
  .cw-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .cw-search {
    max-width: none;
  }

  .cw-card {
    flex-wrap: wrap;
  }

  .cw-card-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?536460ca